import React from "react";
import PropTypes from "prop-types";
import Modal from "../../../components/Modal";
import BatchStockPanel from "./cart/BatchStockPanel";

// "Batches" on a table row (2026-10-30): that medicine's eVital stock batch by batch, read when it
// is opened (ONE get_batches call). Read-only — ordering happens through the cart.
function BatchStockModal({ row, view, lapsingEnabled, lookaheadDays, onClose }) {
    return (
        <Modal title={`Batch-wise stock — ${row.medicineName || "Medicine"}`} onClose={onClose} size="max-w-lg sm:max-w-3xl md:max-w-4xl">
            <BatchStockPanel line={{ itemInventoryId: row.itemInventoryId, view, lapsingEnabled, lookaheadDays }} />
        </Modal>
    );
}

BatchStockModal.propTypes = {
    row: PropTypes.shape({ medicineName: PropTypes.string, itemInventoryId: PropTypes.string }).isRequired,
    view: PropTypes.oneOf(["overall", "new", "reorder"]).isRequired,
    lapsingEnabled: PropTypes.bool,
    lookaheadDays: PropTypes.number,
    onClose: PropTypes.func.isRequired,
};

BatchStockModal.defaultProps = { lapsingEnabled: false, lookaheadDays: undefined };

export default BatchStockModal;
